module.exports = __webpack_public_path__ + "img/blogpost6.1bb32565.jpg";